import axios from "axios";
import Config from "../config";
import { locals } from "../i18n";

const http = axios.create({
  baseURL: Config.MAIN_URL,
  timeout: 30 * 1000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "language": locals()
  },
});

export default http;